import styled, { css } from "styled-components";
import { colors, typeface } from "@sonder/ui/source/styled/theme";

export type TagColor =
  | "blue"
  | "blue2"
  | "blueA"
  | "blue7"
  | "green"
  | "greenDark"
  | "greenLight"
  | "orange"
  | "orangeD"
  | "pink"
  | "purple"
  | "red"
  | "redD"
  | "yellow"
  | "yellowLight"
  | "grayA";

export const getPrimaryColor = (color?: TagColor) => {
  switch (color) {
    case "blue":
    case "blue7":
      return colors.blue7;
    case "blue2":
      return colors.blue2;
    case "blueA":
      return colors.blueA;
    case "green":
      return colors.green;
    case "greenDark":
      return colors.greenDark;
    case "greenLight":
      return colors.greenLight;
    case "orange":
    case "orangeD":
      return colors.orangeD;
    case "pink":
      return colors.pink;
    case "purple":
      return colors.purple;
    case "red":
    case "redD":
      return colors.redD;
    case "yellow":
      return colors.yellow;
    case "yellowLight":
      return colors.yellowLight;
    default:
      return colors.grayA;
  }
};

interface TagProps {
  color?: TagColor;
  filled?: boolean;
}
export const Tag = styled.span<TagProps>`
  align-items: center;
  border-radius: 0.75rem;
  box-sizing: border-box;
  display: inline-flex;
  flex: 0 0 auto;
  font-family: ${typeface.primary};
  font-size: 0.75rem;
  font-weight: bold;
  height: 1.5rem;
  justify-content: center;
  padding: 0 0.75rem;
  user-select: none;

  ${props => {
    const primaryColor = getPrimaryColor(props.color);
    return css`
      border: 1px solid ${primaryColor};
      color: ${props.filled ? colors.white : primaryColor};
      background: ${props.filled ? primaryColor : colors.white};
    `;
  }}
`;
